import SidebarController from './sidebar/SidebarController';
import registerPWA from './pwa/';
import registerWelcomeController from './welcome/WelcomeController';
import registerLoginController from './login/LoginController';
import registerVMDetectionModule from './vm-detection';
import registerHelloUserControllers from './hellouser';
import registerInstructionsController from './instructions/InstructionsController';
import registerOverviewController from './overview/OverviewController';
import registerSheetController from './sheet/SheetController';
import registerHybridTimeController from './hybridTime/HybridTimeController';
import registerInvigilatorMenu from './invigilatorMenu';
import registerTaskDoneController from './taskdone/TaskDoneController';
import registerMediaAssessmentTaskDoneController from './taskdone/MediaAssessmentTaskDoneController';
import registerJournalOptInController from './journalOptIn/JournalOptInController';
import registerResponseSupport from './responseSupport';

export default function registerModules(angular) {
    const assessmentFrontendDirectives = angular.module('assessmentFrontendDirectives');
    const assessmentFrontendControllers = angular.module('assessmentFrontendControllers');
    
    assessmentFrontendControllers.controller('SidebarController', ['$scope', '$bridges', '$signals', '$location', '$config', SidebarController]);
    registerPWA(angular);
    registerWelcomeController(assessmentFrontendControllers);
    registerLoginController(assessmentFrontendControllers);
    registerVMDetectionModule(assessmentFrontendControllers);
    registerHelloUserControllers(assessmentFrontendControllers);
    registerInstructionsController(assessmentFrontendControllers);
    registerOverviewController(assessmentFrontendControllers);
    registerSheetController(assessmentFrontendControllers);
    registerHybridTimeController(assessmentFrontendControllers);
    registerInvigilatorMenu(angular);
    registerTaskDoneController(angular);
    registerMediaAssessmentTaskDoneController(angular);
    registerJournalOptInController(angular);
    registerResponseSupport(angular);
}
